import React from 'react';

import { colors } from '@styleseat/brand';
import NotificationBanner from '../NotificationBanner';
import { TimeCalendarDeleteIcon } from '../../../ui/Icons';
import { NotificationProps } from './useAppointmentCancelledNotification';

type NcdAppointmentCancelledNotificationProviderNoShowProps = {
  onCTAClick: () => void;
  notification: NotificationProps;
  clientName: string;
};

const NcdAppointmentCancelledNotificationProviderNoShow:
React.FC<NcdAppointmentCancelledNotificationProviderNoShowProps> = ({
  onCTAClick,
  notification,
  clientName,
}) => (
  <NotificationBanner
    icon={TimeCalendarDeleteIcon}
    notification={notification}
    iconColor={colors.ash}
    buttonProps={{
      text: 'Contact Customer Support',
      size: 'small',
      appearance: 'outline-thin',
      onClick: onCTAClick,
    }}
    highlightedText={`You marked ${clientName} as a no show.`}
    text="Contact customer support to request a refund of the New Client Fee you paid upfront."
  />
);

export default NcdAppointmentCancelledNotificationProviderNoShow;
